var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skip_box"},[_c('div',{attrs:{"id":"skipMobileQr"}}),_c('p',{staticClass:"skip_text"},[_vm._v("请使用手机扫码访问")])])
}]

export { render, staticRenderFns }